import React, { useState, useRef, useEffect } from 'react';
import { Mail, Clock, ChevronRight, Download, Share2, Sparkles, X } from 'lucide-react';
import { toast } from 'sonner';
import { Link, useLocation } from 'react-router-dom';
import html2canvas from 'html2canvas';
import ShareButtons from './ShareButtons';
import GiftPromoCard from './GiftPromoCard';

const HUMMINGBIRD_URL = 'https://customer-assets.emergentagent.com/job_1b90f8c6-d70e-4858-8e6c-d4275accd79b/artifacts/l4bmy3e4_Official%20Hummingbird%20for%20TAV%20The%20Alchemy%20Village%20.png';

const CATEGORIES = ['All', 'Wednesday Wake-Up', 'Thoughts', 'Teaching', 'Recipe', 'Story', 'Inspiration'];

const POSTS = [
  {
    id: 6,
    title: 'Red Flags in Life',
    subtitle: "They're not confusion — they're clarity you don't want to accept.",
    category: 'Wednesday Wake-Up',
    date: 'April 29, 2026',
    readTime: '8 min read',
    heroImage: 'https://customer-assets.emergentagent.com/job_5d4ad1e7-aed7-4c2c-bd02-652824eb659e/artifacts/83e3h27v_WWU%20RED%20FLAGS%20.png',
    content: [
      { type: 'opening', text: '\ud83d\udea8 WWU \u2013 Wednesday Wake UP\u2026 CALL \ud83d\udea8' },
      { type: 'paragraph', text: 'THIS is your alarm. Not gentle\u2026 not cute\u2026 but REAL.' },
      { type: 'paragraph', text: 'Let\u2019s talk about it\u2026' },

      { type: 'subheading', text: '\ud83d\udd34 RED FLAGS Are NOT Confusion' },
      { type: 'emphasis', text: 'They\u2019re clarity you don\u2019t want to accept.' },
      { type: 'paragraph', text: 'You saw it.\nYou felt it.\nYou KNEW it.' },
      { type: 'paragraph', text: 'But then\u2026 here comes that voice:' },
      { type: 'revelation', text: '"But what if it doesn\u2019t work out?"\n"What if I regret leaving?"\n"What if I can\u2019t find better?"' },
      { type: 'paragraph', text: 'So you stay.\nIn the job.\nIn the relationship.\nIn the environment.' },
      { type: 'emphasis', text: 'Not because it\u2019s right\u2026\nBut because it\u2019s familiar.' },

      { type: 'subheading', text: '\ud83d\udca5 Here\u2019s the WAKE UP' },
      { type: 'revelation', text: 'You\u2019re not afraid of the unknown\u2026\nYou\u2019re afraid of meeting yourself there.' },
      { type: 'paragraph', text: 'Because in the UNKNOWN\u2026' },
      { type: 'emphasis', text: '\ud83d\udc49 You don\u2019t get to hide behind excuses\n\ud83d\udc49 You don\u2019t get to blame the job, the person, the situation\n\ud83d\udc49 You meet the version of YOU that has to decide, trust, and move' },

      { type: 'subheading', text: '\ud83c\udf1f Flip the Script' },
      { type: 'paragraph', text: 'What if\u2026' },
      { type: 'revelation', text: 'The UNKNOWN is your FRIEND?' },
      { type: 'paragraph', text: 'What if it\u2019s the place where:' },
      { type: 'emphasis', text: 'Your REAL opportunities are waiting\nYour PEACE is waiting\nYour NEXT LEVEL is waiting\nYour TRUE SELF is waiting' },

      { type: 'subheading', text: '\ud83d\udd25 Let\u2019s Get Real for a Second\u2026' },
      { type: 'paragraph', text: 'Every time you ignore a red flag\u2026\nYou\u2019re saying:' },
      { type: 'revelation', text: '"I don\u2019t trust myself."' },
      { type: 'paragraph', text: 'And every time you choose comfort over truth\u2026' },
      { type: 'emphasis', text: 'You delay your OWN life.' },

      { type: 'subheading', text: '\ud83e\udded Your CALL Today' },
      { type: 'paragraph', text: 'Answer this \u2014 don\u2019t dance around it:' },
      { type: 'emphasis', text: 'Where in my life am I seeing RED FLAGS\u2026 and pretending they\u2019re pink?\nWhat am I REALLY afraid of losing\u2026 comfort or myself?\nWhat decision have I already made\u2026 but haven\u2019t honored?' },

      { type: 'subheading', text: '\ud83d\udc8e The Truth (Cabrini Style)' },
      { type: 'paragraph', text: 'Finally Understanding Common Knowledge\u2026\nThings Happen All The Time.' },
      { type: 'emphasis', text: 'Red flags aren\u2019t special.\nThey\u2019re standard.' },
      { type: 'revelation', text: 'What\u2019s NOT standard\u2026 is YOU finally choosing YOU.' },

      { type: 'subheading', text: '\ud83d\udd14 WAKE UP CALL Activated' },
      { type: 'emphasis', text: 'You don\u2019t need more time.\nYou don\u2019t need more signs.' },
      { type: 'revelation', text: 'You need a DECISION.' },
      { type: 'paragraph', text: '\u27a1\ufe0f Make the decision\n\u27a1\ufe0f Trust your decision\n\u27a1\ufe0f Stay focused\n\u27a1\ufe0f Take inspired action\n\u27a1\ufe0f And ENJOY the journey\u2026 even into the UNKNOWN' },

      { type: 'closing', text: 'Because over there\u2026\n\nIs where your LIFE is waiting. \ud83d\udcab' },
      { type: 'signature', text: '\u2014 Cabrini' },
    ],
  },
  {
    id: 5,
    title: 'Answer the CALL',
    subtitle: 'The GOOD is calling too. Will you answer?',
    category: 'Wednesday Wake-Up',
    date: 'April 22, 2026',
    readTime: '7 min read',
    heroImage: 'https://customer-assets.emergentagent.com/job_5d4ad1e7-aed7-4c2c-bd02-652824eb659e/artifacts/cxfq167h_WWU-Wednesday%20Wake%20Up%20CALL...png',
    content: [
      { type: 'opening', text: 'WAKE. UP.' },
      { type: 'paragraph', text: 'This is your alarm.\nNot because something bad happened.\nNot because life is falling apart.\nBut because maybe \u2014 just maybe \u2014 something GOOD is trying to get in\u2026 and you\u2019re about to doubt it away.' },
      { type: 'paragraph', text: 'Somewhere along the line, people got taught this lie:' },
      { type: 'revelation', text: '"If it\u2019s too good to be true, it probably is."' },
      { type: 'paragraph', text: 'And because of that, when something beautiful shows up\u2026\nwhen peace shows up\u2026\nwhen love shows up\u2026\nwhen opportunity shows up\u2026\nwhen clarity shows up\u2026\nwhen the thing you asked for finally knocks on your door\u2026' },
      { type: 'emphasis', text: 'you hesitate.' },
      { type: 'paragraph', text: 'You question it.\nYou shrink from it.\nYou side-eye it.\nYou talk yourself out of it.\nYou tell yourself not to get excited.\nYou decide it can\u2019t be real.' },
      { type: 'paragraph', text: 'And in doing that\u2026' },
      { type: 'emphasis', text: 'you stop trusting the GOOD.\nWorse \u2014 you stop trusting yourself to receive it.' },
      { type: 'paragraph', text: 'But what if the truth is this:' },
      { type: 'revelation', text: 'What if when it\u2019s soooo GOOD\u2026 it\u2019s TRUE?' },
      { type: 'paragraph', text: 'What if the good things happen too?\nWhat if life is not only trying to break you \u2014\nwhat if life is also trying to bless you?' },
      { type: 'paragraph', text: 'What if the CALL on your life is not always wrapped in pain?\nWhat if sometimes the CALL comes wrapped in joy?\nIn ease?\nIn alignment?\nIn answered prayer?\nIn the very thing you\u2019ve been asking God in you to reveal?' },
      { type: 'paragraph', text: 'And because you\u2019ve been so conditioned to brace for bad news,\nyou miss the miracle trying to meet you.' },
      { type: 'subheading', text: 'That\u2019s What Wednesday Wake-Up Is About' },
      { type: 'paragraph', text: 'This is the day we stop and ask:' },
      { type: 'emphasis', text: 'What is calling me right now?\nIs it pain trying to teach me?\nOr is it goodness trying to reach me?\nIs this moment asking me to wake up, choose differently, and finally trust what is showing up in my life?' },
      { type: 'paragraph', text: 'Because life ain\u2019t all bad.' },
      { type: 'paragraph', text: 'Read that again:' },
      { type: 'revelation', text: 'Life ain\u2019t all bad.' },
      { type: 'paragraph', text: 'Some of it is about how you\u2019re looking at it.\nHow you\u2019re receiving it.\nHow quickly you dismiss what feels unfamiliar just because it feels good.' },
      { type: 'paragraph', text: 'Some women have gotten so used to survival\nthat peace feels suspicious.\nSome have lived in struggle so long\nthat ease feels fake.\nSome have been disappointed so many times\nthat when something real arrives,\nthey don\u2019t answer the CALL \u2014\nthey answer their fear.' },
      { type: 'subheading', text: 'In The Village, On Wednesdays, We Wake That Up' },
      { type: 'paragraph', text: 'We come here to recognize the CALL.\nThe call to truth.\nThe call to healing.\nThe call to trust.\nThe call to stop rejecting the very thing that may have been sent for us.' },
      { type: 'emphasis', text: 'Because every CALL is not a warning.' },
      { type: 'paragraph', text: 'Some CALLS are invitations.\nSome CALLS are confirmations.\nSome CALLS are reminders that your life is still speaking to you \u2014\nand not everything it says is negative.' },
      { type: 'paragraph', text: 'Sometimes life is saying:' },
      { type: 'revelation', text: 'Here.\nThis is for you.\nTake it.\nTrust it.\nReceive it.\nAnswer it.' },
      { type: 'subheading', text: 'So This Wednesday, Let This Be Your Wake-Up' },
      { type: 'emphasis', text: 'Stop doubting the GOOD.\nStop doubting yourself.\nAnd answer the CALL.' },
      { type: 'paragraph', text: 'Because maybe the reason you\u2019re being awakened\nis not because something is wrong\u2026' },
      { type: 'closing', text: 'Maybe it\u2019s because something is finally, beautifully,\nright.' },
      { type: 'signature', text: '\u2014 Cabrini' },
    ],
  },
  {
    id: 4,
    title: 'Let It Die, Let Me Rise',
    subtitle: 'A Spirit Sunday Reflection from The Alchemy Village',
    category: 'Inspiration',
    date: 'April 27, 2026',
    readTime: '10 min read',
    content: [
      { type: 'opening', text: 'There comes a moment in every woman\u2019s life when she has to tell the truth.' },
      { type: 'paragraph', text: 'Not the polished truth.\nNot the version that sounds good to everybody else.\nNot the truth she has learned to perform so she can stay liked, needed, chosen, or safe.' },
      { type: 'emphasis', text: 'The real truth.' },
      { type: 'paragraph', text: 'The truth that says:' },
      { type: 'revelation', text: 'I cannot become who I say I want to be while holding on to what no longer serves me.' },
      { type: 'paragraph', text: 'That is the spirit behind the song "Let It Die, Let Me Rise."\nThis is not just a lyric. It is a declaration. A release. A decision. A resurrection.' },
      { type: 'paragraph', text: 'Because sometimes what needs to "die" is not a person.\nIt is a pattern.\nA mindset.\nA fear.\nAn excuse.\nAn identity built in survival mode.' },
      { type: 'emphasis', text: 'Sometimes what needs to go is the version of you that learned how to make pain feel normal.' },
      { type: 'paragraph', text: 'And whew\u2026 that part is real.' },
      { type: 'subheading', text: 'What Are You Still Carrying?' },
      { type: 'paragraph', text: 'So many of us are carrying old pain like it still belongs to us.' },
      { type: 'paragraph', text: 'We carry guilt from things we should have forgiven ourselves for years ago.\nWe carry fear that was born in another season.\nWe carry stories about who we are that were written by disappointment, rejection, betrayal, failure, or loss.' },
      { type: 'emphasis', text: 'And then we wonder why we feel heavy.' },
      { type: 'paragraph', text: 'We wonder why we cannot hear ourselves clearly.\nWhy we feel disconnected.\nWhy we keep saying we want more, while clinging to what keeps us small.' },
      { type: 'paragraph', text: 'The song says:' },
      { type: 'revelation', text: 'Let it die, let me rise.' },
      { type: 'paragraph', text: 'That means something.' },
      { type: 'paragraph', text: 'It means I am no longer worshipping my wounds.\nIt means I am no longer rehearsing the same pain and calling it my personality.\nIt means I am no longer choosing what is familiar over what is freeing.' },
      { type: 'emphasis', text: 'It means I am ready to rise.' },
      { type: 'subheading', text: 'This Is the Work of Alchemy' },
      { type: 'paragraph', text: 'At The Alchemy Village, this is the work.' },
      { type: 'paragraph', text: 'We help people see what is no longer aligned with the life they say they want.\nWe create space to pause, reflect, and ask the deeper questions that change everything:' },
      { type: 'emphasis', text: 'Who are you?\nWhat do you want?\nWhy do you want it?' },
      { type: 'paragraph', text: 'These are the 3 core questions at the heart of Cabrini\u2019s Law of F.U.C.K. T.H.A.T.T.\nFinally Understanding Common Knowledge: Things Happen All The Time.' },
      { type: 'paragraph', text: 'Life happens.\nDisappointment happens.\nDetours happen.\nHeartbreak happens.\nBut none of it has the power to define you unless you build your identity around it.' },
      { type: 'revelation', text: 'Alchemy is the moment you decide to stop being ruled by what happened and start being guided by who you are becoming.' },
      { type: 'paragraph', text: 'That is why the song is so important.' },
      { type: 'paragraph', text: 'It is not just about release.\nIt is about choice.' },
      { type: 'subheading', text: 'Rising Requires a Decision' },
      { type: 'paragraph', text: 'You do not "accidentally" rise.' },
      { type: 'emphasis', text: 'You rise because you make a decision.' },
      { type: 'paragraph', text: 'A decision to stop betraying yourself.\nA decision to stop shrinking.\nA decision to trust the God in YOU more than the fear in front of you.' },
      { type: 'paragraph', text: 'That is where the 5 principles come alive:' },
      { type: 'paragraph', text: 'Make a decision\nTrust your decision\nStay focused\nTake inspired action\nEnjoy your journey along the way' },
      { type: 'paragraph', text: '"Let It Die, Let Me Rise" is a musical expression of these principles.' },
      { type: 'paragraph', text: 'It is the sound of someone saying:' },
      { type: 'emphasis', text: 'I have cried enough.\nI have doubted enough.\nI have carried enough.\nNow I choose me.' },
      { type: 'paragraph', text: 'Not the ego version.\nNot the defensive version.\nThe true version.' },
      { type: 'paragraph', text: 'The awake version.\nThe whole version.\nThe version that knows she is here to live, not just survive.' },
      { type: 'subheading', text: 'Letting Go Is Not Losing' },
      { type: 'paragraph', text: 'One of the biggest lies we tell ourselves is that letting go means losing something.' },
      { type: 'emphasis', text: 'But what if letting go is actually how you make room?' },
      { type: 'paragraph', text: 'What if the thing you keep trying to save is the very thing keeping you from your next level of peace, clarity, joy, and purpose?' },
      { type: 'paragraph', text: 'What if the old story has to die so your real voice can rise?' },
      { type: 'paragraph', text: 'That is what this song is about.' },
      { type: 'paragraph', text: 'It is about spiritual housecleaning.\nIt is about emotional honesty.\nIt is about no longer dragging dead weight into a life you say you want to enjoy.' },
      { type: 'paragraph', text: 'There is power in saying:' },
      { type: 'revelation', text: 'I release what I no longer need.\nI bless what taught me.\nI stop romanticizing what hurt me.\nI trust what is trying to emerge in me now.' },
      { type: 'emphasis', text: 'That is not weakness.\nThat is wisdom.' },
      { type: 'subheading', text: 'What Needs to Die in You?' },
      { type: 'paragraph', text: 'That is the question.' },
      { type: 'paragraph', text: 'Maybe it is your fear of being seen.\nMaybe it is your addiction to struggle.\nMaybe it is the identity you created just to survive a hard season.\nMaybe it is the habit of waiting for permission.\nMaybe it is the lie that it is too late.' },
      { type: 'emphasis', text: 'Whatever it is, be honest.' },
      { type: 'paragraph', text: 'Because resurrection does not happen where there is denial.\nIt happens where there is truth.' },
      { type: 'paragraph', text: 'And truth says:' },
      { type: 'revelation', text: 'You are allowed to outgrow what once held you together.' },
      { type: 'subheading', text: 'A Message from The Village' },
      { type: 'paragraph', text: 'At The Alchemy Village, we believe becoming is sacred.' },
      { type: 'paragraph', text: 'We believe you are not broken.\nWe believe there is nothing wrong with you.\nWe believe the God in YOU is still speaking.\nAnd we believe that when you finally stop holding on to what no longer fits, you create room for your real life to begin.' },
      { type: 'paragraph', text: 'That is why this song belongs here.' },
      { type: 'paragraph', text: 'It sounds like freedom.\nIt sounds like release.\nIt sounds like a woman coming back to herself.' },
      { type: 'emphasis', text: 'So let this be your reminder today:' },
      { type: 'paragraph', text: 'You do not have to carry the old version of you into the next chapter.\nYou do not have to keep feeding what is already dead.\nYou do not have to keep explaining why you are ready.' },
      { type: 'paragraph', text: 'You can decide now.' },
      { type: 'revelation', text: 'You can let it die.\nAnd you can rise.' },
      { type: 'subheading', text: 'Spirit Sunday Reflection' },
      { type: 'paragraph', text: 'Take a moment and sit with this:' },
      { type: 'emphasis', text: 'What part of me is asking to be released so the real me can rise?' },
      { type: 'paragraph', text: 'Write it down.\nPray over it.\nSpeak it out loud.\nThen make the decision to stop carrying what your soul is trying to put down.' },
      { type: 'paragraph', text: 'Because your becoming is waiting on your honesty.' },
      { type: 'paragraph', text: 'And here in The Alchemy Village, we honor that journey.' },
      { type: 'closing', text: 'Welcome to YOU.\n\nIf this message spoke to your spirit, then you already know: something in you is ready.\n\nThe Alchemy Village is a place for people who are ready to stop sleep-walking through life and start becoming who they were always meant to be. Through reflection, transformation, truth-telling, and soul work, we walk the path back to self.\n\nLet it die. Let you rise.' },
      { type: 'signature', text: '\u2014 Cabrini' },
    ],
  },
  {
    id: 3,
    title: 'Happy Resurrection Day: Rise Into Who You Are Meant to Be',
    subtitle: 'Let it go so you can rise. This is your moment of becoming.',
    category: 'Inspiration',
    date: 'April 20, 2026',
    readTime: '6 min read',
    content: [
      { type: 'opening', text: 'There comes a moment in your life when you have to make a decision...' },
      { type: 'paragraph', text: 'Not a soft decision. Not a "let me think about it" decision.' },
      { type: 'emphasis', text: 'A real decision.' },
      { type: 'paragraph', text: 'The kind that says: "This version of me... no longer serves me."' },
      { type: 'subheading', text: 'Let It Go So You Can Rise' },
      { type: 'paragraph', text: "Resurrection isn't just a spiritual concept. It's a lifestyle." },
      { type: 'paragraph', text: "It's the moment you look at your life and say: This relationship? No. This mindset? No. This fear I've been holding onto? No." },
      { type: 'paragraph', text: 'And with power in your voice, your spirit, your soul... you say:' },
      { type: 'revelation', text: 'F.U.C.K. T.H.A.T.T.' },
      { type: 'paragraph', text: "Because Finally Understanding Common Knowledge \u2014 Things Happen All The Time means this: Things fall apart. Things don't go your way. Things end." },
      { type: 'emphasis', text: 'And they are SUPPOSED to.' },
      { type: 'paragraph', text: 'Why? So something new... something aligned... something TRUE can rise.' },
      { type: 'subheading', text: "Death Is Not The End \u2014 It's The Beginning" },
      { type: 'paragraph', text: "Let's tell the truth..." },
      { type: 'paragraph', text: "You can't rise while holding onto what's weighing you down. You can't become HER while still protecting the version of you that's afraid to let go." },
      { type: 'emphasis', text: 'Resurrection requires release.' },
      { type: 'paragraph', text: "Release the story. Release the struggle. Release the identity that no longer fits." },
      { type: 'paragraph', text: "Because every time you hold onto what's not serving you... you delay what's trying to come through you." },
      { type: 'subheading', text: 'Inside The Alchemy Village...' },
      { type: 'paragraph', text: "This is where it gets real... Because in The Alchemy Village, you don't have to guess anymore. You begin to SEE clearly." },
      { type: 'paragraph', text: "You see what's been holding you back. You see the patterns. You see the truth you've been avoiding." },
      { type: 'paragraph', text: "And here's the shift... You don't just see it..." },
      { type: 'revelation', text: 'You gain the confidence to say: "I trust what\u2019s coming next."' },
      { type: 'paragraph', text: "Not because you have all the answers... but because you've finally connected to the God in YOU." },
      { type: 'subheading', text: 'This Is Your Resurrection Moment' },
      { type: 'paragraph', text: 'Right here. Right now.' },
      { type: 'paragraph', text: 'Ask yourself: Who am I... without the fear? What do I want... without limitation? Why do I want it... for real?' },
      { type: 'emphasis', text: 'And then... make the decision.' },
      { type: 'paragraph', text: 'Trust your decision. Stay focused. Take inspired action. And enjoy your journey along the way.' },
      { type: 'paragraph', text: '(You know the principles... now LIVE them.)' },
      { type: 'subheading', text: 'Final Word' },
      { type: 'paragraph', text: 'You are not stuck. You are not lost. You are not behind.' },
      { type: 'emphasis', text: 'You are in a moment of becoming.' },
      { type: 'paragraph', text: "And everything that's falling away? It's making space for you to RISE." },
      { type: 'paragraph', text: "So today... say it with your whole chest..." },
      { type: 'revelation', text: 'F.U.C.K. T.H.A.T.T.\n...and step into the life that\u2019s been waiting on YOU.' },
      { type: 'paragraph', text: "If you're ready to stop holding on... and start rising..." },
      { type: 'closing', text: "Welcome to The Alchemy Village.\nWhere you don't just find yourself...\nYou become." },
      { type: 'signature', text: '\u2014 Cabrini' },
    ],
  },
  {
    id: 2,
    title: 'Church Is Where You ARE',
    subtitle: 'Spirit Sunday finds its home in The Alchemy Village.',
    category: 'Inspiration',
    date: 'March 29, 2026',
    readTime: '4 min read',
    content: [
      { type: 'opening', text: 'Good morning, good afternoon, good evening \u2014 welcome to Spirit Sunday. The day before Monday. What will you be driving towards... freedom or bondage? You get to choose.' },
      { type: 'paragraph', text: 'Now, some of y\u2019all went to church today. Some of y\u2019all did pillow church. Some of y\u2019all prayed in the car, on a walk, in the shower, in silence. It doesn\u2019t matter. Church is where you ARE.' },
      { type: 'paragraph', text: 'And that\u2019s exactly why I built this place.' },
      { type: 'paragraph', text: 'The Alchemy Village isn\u2019t about telling you what to believe. It\u2019s not about religion. It\u2019s not about replacing whatever you already hold sacred. It\u2019s about something deeper than that.' },
      { type: 'emphasis', text: 'It\u2019s about the thing underneath the thing.' },
      { type: 'paragraph', text: 'The question you\u2019ve been whispering to yourself when nobody\u2019s listening: Who am I... really? The restlessness that won\u2019t go away no matter how many times you say "I\u2019m fine." The knowing \u2014 that quiet, stubborn knowing \u2014 that there is something MORE waiting for you.' },
      { type: 'emphasis', text: 'That\u2019s what\u2019s been brewing.' },
      { type: 'paragraph', text: 'For years, I\u2019ve been pouring into SpiritSunday \u2014 showing up every week, giving everything I had. And it taught me something: the message never runs out. But the messenger? She needs a Village too.' },
      { type: 'paragraph', text: 'So here we are.' },
      { type: 'paragraph', text: 'This is where SpiritSunday lives now. Not just on a podcast. Not just on a Sunday. But in a place you can walk through \u2014 six paths, each one built from a chapter of my life. A mirror that asks you the questions you\u2019ve been avoiding. A journal where your truth has room to breathe. Music that moves your soul. And a community of Village Manifestors who are done pretending and ready to become.' },
      { type: 'revelation', text: 'It doesn\u2019t matter who you serve \u2014 God, the Universe, Source, the ancestors, or the fire inside your own chest. The Alchemy Village was built for ALL of it. Because the God in you? That\u2019s not a religion. That\u2019s a FACT.' },
      { type: 'paragraph', text: 'Something is coming. You can feel it. That\u2019s why you\u2019re here.' },
      { type: 'closing', text: 'Welcome to Spirit Sunday at The Alchemy Village.\nNow... what will you be driving towards?' },
      { type: 'signature', text: '\u2014 Cabrini' },
    ],
  },
  {
    id: 1,
    title: 'The God in ME',
    subtitle: 'How a word I didn\'t understand became the foundation of everything.',
    category: 'Thoughts',
    date: 'March 28, 2026',
    readTime: '3 min read',
    content: [
      { type: 'opening', text: 'Wow... What is this place? It feels so magical. I forgot why I was sad.' },
      { type: 'paragraph', text: 'That is what happened when I started imagining this place.' },
      { type: 'paragraph', text: 'I remember when I first heard about "The Alchemist" \u2014 the book. My sister Donna said to me one day, "Cabrini, you\u2019re an Alchemist." I didn\u2019t know what it meant. She said: you go through so much \u2014 as you\u2019ll see in the book \u2014 and you change it into something positive.' },
      { type: 'paragraph', text: 'At the time, I didn\u2019t want to hear the word GOD. People would say "HE" or "The blood of Jesus" or "Leave it in HIS hands" \u2014 and I watched people hold onto their faith through the hardest things imaginable. That was beautiful. Believing was clearly powerful \u2014 I could see that. I respected it. I just couldn\u2019t find mine. I hadn\u2019t found the language that made sense to ME. Not yet.' },
      { type: 'paragraph', text: 'It wasn\u2019t until I started practicing Buddhism that I started to understand karma. What you do has consequences. That was in 1986.' },
      { type: 'emphasis', text: 'WOW. I just realized that was 40 years ago.' },
      { type: 'paragraph', text: 'Now I know that what I\u2019ve been looking for all the while... is in ME.' },
      { type: 'paragraph', text: 'There are some quotes from the Bible that stuck with me. The one I hold dear is: "You are the image and likeness."' },
      { type: 'paragraph', text: 'I thought... Well, if I am the image and likeness of GOD...' },
      { type: 'revelation', text: 'Then I AM God. God is in ME.' },
      { type: 'closing', text: 'Welcome to The Alchemy Village.\nWelcome to YOU.' },
    ],
  },
];

function PostCard({ post, onOpen }) {
  const isWWU = post.category === 'Wednesday Wake-Up';
  return (
    <article
      className={`vd-post-card ${post.heroImage ? 'vd-post-card--hero' : ''} ${isWWU ? 'vd-post-card--wwu' : ''}`}
      data-testid={`post-card-${post.id}`}
      onClick={() => onOpen(post.id)}
    >
      {post.heroImage && (
        <div className="vd-post-card-hero">
          <img src={post.heroImage} alt="" loading="lazy" />
        </div>
      )}
      <div className="vd-post-card-body">
        <div className="vd-post-card-top">
          <span className={`vd-post-cat-tag ${isWWU ? 'vd-post-cat-tag--wwu' : ''}`}>{post.category}</span>
          <span className="vd-post-date">{post.date}</span>
        </div>
        <h3 className="vd-post-card-title">{post.title}</h3>
        <p className="vd-post-card-subtitle">{post.subtitle}</p>
        <div className="vd-post-card-footer">
          <span className="vd-post-read-time"><Clock size={14} /> {post.readTime}</span>
          <span className="vd-post-read-more">Read <ChevronRight size={14} /></span>
        </div>
      </div>
    </article>
  );
}

function PostFull({ post, onClose }) {
  const [showShareCard, setShowShareCard] = useState(false);
  const shareRef = useRef(null);

  const handleDownloadCard = async () => {
    if (!shareRef.current) return;
    try {
      const canvas = await html2canvas(shareRef.current, { backgroundColor: null, scale: 2, useCORS: true });
      const link = document.createElement('a');
      link.download = `tav-${post.title.replace(/[^a-zA-Z]/g, '-').toLowerCase()}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
      toast.success('Card saved! Share it everywhere.');
    } catch { toast.error('Could not generate image.'); }
  };

  const postUrl = `https://thealchemyvillage.com/daily?post=${post.id}`;
  const postShareText = `${post.title} — by Cabrini Schnyder. ${post.subtitle || ''}`;
  const isWWU = post.category === 'Wednesday Wake-Up';

  return (
    <article className="vd-post-full" data-testid={`post-full-${post.id}`}>
      <button className="vd-post-back" data-testid="post-back-btn" onClick={onClose}>
        &larr; Back to The Village Daily
      </button>
      {post.heroImage && (
        <div className="vd-post-full-hero" data-testid="post-hero">
          <img src={post.heroImage} alt={post.title} />
        </div>
      )}
      <div className="vd-post-full-meta">
        <span className={`vd-post-cat-tag ${isWWU ? 'vd-post-cat-tag--wwu' : ''}`}>{post.category}</span>
        <span className="vd-post-date">{post.date}</span>
        <span className="vd-post-read-time"><Clock size={14} /> {post.readTime}</span>
      </div>
      <h1 className="vd-post-full-title" data-testid="post-title">{post.title}</h1>
      <p className="vd-post-full-subtitle">{post.subtitle}</p>
      <div className="vd-post-full-author">
        <span>by Cabrini Schnyder</span>
      </div>
      <div className="vd-post-body" data-testid="post-body">
        {post.content.map((block, i) => {
          switch (block.type) {
            case 'opening':
              return <p key={i} className="vd-post-opening">{block.text}</p>;
            case 'emphasis':
              return <p key={i} className="vd-post-emphasis">{block.text}</p>;
            case 'revelation':
              return <blockquote key={i} className="vd-post-revelation">{block.text.split('\n').map((line, j) => <span key={j}>{line}<br/></span>)}</blockquote>;
            case 'subheading':
              return <h3 key={i} className="vd-post-subheading">{block.text}</h3>;
            case 'closing':
              return (
                <div key={i} className="vd-post-closing">
                  {block.text.split('\n').map((line, j) => (
                    <p key={j}>{line}</p>
                  ))}
                </div>
              );
            case 'signature':
              return <p key={i} className="vd-post-signature">{block.text}</p>;
            default:
              return <p key={i} className="vd-post-paragraph">{block.text}</p>;
          }
        })}
      </div>

      {/* Share Row (social networks) */}
      <ShareButtons url={postUrl} title={post.title} text={postShareText} variant="gold" />

      {/* Shareable Image Card toggle */}
      <div className="vd-post-share" data-testid="post-share-actions">
        <button className="vd-share-btn" data-testid="post-share-card-btn" onClick={() => setShowShareCard(!showShareCard)}>
          <Share2 size={16} /> {showShareCard ? 'Hide Image Card' : 'Download Image Card'}
        </button>
      </div>

      {/* Shareable Card */}
      {showShareCard && (
        <div className="vd-sharecard-wrap">
          <div ref={shareRef} className="vd-sharecard" data-testid="post-share-card">
            <div className="vd-sharecard-inner">
              <p className="vd-sharecard-brand">THE ALCHEMY VILLAGE</p>
              <h2 className="vd-sharecard-title">{post.title}</h2>
              <p className="vd-sharecard-sub">{post.subtitle}</p>
              <div className="vd-sharecard-divider" />
              <p className="vd-sharecard-author">by Cabrini Schnyder</p>
              <p className="vd-sharecard-tagline">F.U.C.K. T.H.A.T.T.</p>
              <p className="vd-sharecard-url">thealchemyvillage.com</p>
            </div>
          </div>
          <div className="vd-sharecard-actions">
            <button className="vd-share-btn vd-share-download" data-testid="post-download-card" onClick={handleDownloadCard}>
              <Download size={16} /> Save Image
            </button>
          </div>
        </div>
      )}

      <div className="vd-post-end-cta">
        <p>This story lives because of The Alchemy Village.</p>
        <Link to="/quiz" className="village-btn village-btn--secondary" data-testid="post-quiz-link">Discover Your Archetype</Link>
      </div>
    </article>
  );
}

const WWU_BANNER_STORAGE_KEY = 'tav-wwu-latest-seen-id';

function WWUBanner({ post, onRead, onDismiss }) {
  // Truncate subtitle if very long for clean layout
  const sub = post.subtitle && post.subtitle.length > 110 ? post.subtitle.slice(0, 107) + '…' : post.subtitle;
  return (
    <div className="wwu-banner" data-testid="wwu-banner" role="region" aria-label="Latest Wednesday Wake-Up">
      <div className="wwu-banner-glow" aria-hidden="true" />
      <button
        type="button"
        className="wwu-banner-close"
        data-testid="wwu-banner-close"
        onClick={onDismiss}
        aria-label="Dismiss banner"
      >
        <X size={16} strokeWidth={2} />
      </button>
      <div className="wwu-banner-inner">
        <div className="wwu-banner-badge">
          <Sparkles size={14} strokeWidth={2} />
          <span>Latest CALL</span>
        </div>
        <div className="wwu-banner-text">
          <p className="wwu-banner-eyebrow">Wednesday Wake-Up · {post.date}</p>
          <h2 className="wwu-banner-headline" data-testid="wwu-banner-title">{post.title}</h2>
          {sub && <p className="wwu-banner-sub">{sub}</p>}
        </div>
        <button
          type="button"
          className="wwu-banner-cta"
          data-testid="wwu-banner-read"
          onClick={onRead}
        >
          Read this week's CALL
          <ChevronRight size={16} strokeWidth={2.2} />
        </button>
      </div>
    </div>
  );
}

export default function VillageDailyPage() {
  const location = useLocation();

  // Map URL slug → category label (e.g. ?cat=wednesday-wake-up → "Wednesday Wake-Up")
  const slugToCategory = (slug) => {
    if (!slug) return null;
    const match = CATEGORIES.find((c) => c.toLowerCase().replace(/[^a-z0-9]+/g, '-') === slug.toLowerCase());
    return match || null;
  };

  const initialCategory = (() => {
    const params = new URLSearchParams(location.search);
    return slugToCategory(params.get('cat')) || 'All';
  })();

  const [activeCategory, setActiveCategory] = useState(initialCategory);
  const [email, setEmail] = useState('');
  const [openPostId, setOpenPostId] = useState(null);

  // Sync category when URL query changes (e.g. user clicks a nav dropdown item while already on /daily)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const fromUrl = slugToCategory(params.get('cat'));
    if (fromUrl) {
      setActiveCategory(fromUrl);
      setOpenPostId(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const filteredPosts = activeCategory === 'All'
    ? POSTS
    : POSTS.filter(p => p.category === activeCategory);

  const openPost = POSTS.find(p => p.id === openPostId);

  // Latest WWU post = highest id in the WWU category (POSTS are ordered newest-first by id)
  const latestWWUPost = POSTS.filter(p => p.category === 'Wednesday Wake-Up')
    .sort((a, b) => b.id - a.id)[0];

  // Banner shows whenever the latest WWU post hasn't been seen yet
  const [wwuBannerHidden, setWwuBannerHidden] = useState(() => {
    if (!latestWWUPost) return true;
    try {
      const seen = typeof window !== 'undefined' ? localStorage.getItem(WWU_BANNER_STORAGE_KEY) : null;
      return seen === String(latestWWUPost.id);
    } catch {
      return false;
    }
  });

  const markBannerSeen = () => {
    if (!latestWWUPost) return;
    try { localStorage.setItem(WWU_BANNER_STORAGE_KEY, String(latestWWUPost.id)); } catch { /* ignore */ }
    setWwuBannerHidden(true);
  };

  // Auto-hide banner when reader opens the latest WWU post
  useEffect(() => {
    if (openPost && latestWWUPost && openPost.id === latestWWUPost.id && !wwuBannerHidden) {
      markBannerSeen();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openPostId]);

  const handleBannerRead = () => {
    if (latestWWUPost) {
      setOpenPostId(latestWWUPost.id);
      markBannerSeen();
    }
  };

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      toast.success('Welcome to The Village Daily!');
      setEmail('');
    }
  };

  const showWWUBanner = !wwuBannerHidden && !openPost && latestWWUPost;

  return (
    <section data-testid="village-daily-page" className="vd">
      {/* Hero */}
      <div className="vd-hero">
        <img alt="" className="vd-hummingbird" src={HUMMINGBIRD_URL} />
        <div className="vd-hero-text">
          <h1 className="vd-title" data-testid="daily-title">The Village Daily</h1>
          <p className="vd-subtitle">Thoughts. Teachings. Nourishment for the Soul.</p>
        </div>
      </div>

      <div className="vd-body">
        {openPost ? (
          <PostFull post={openPost} onClose={() => setOpenPostId(null)} />
        ) : (
          <>
            {/* WWU series launch banner */}
            {showWWUBanner && (
              <WWUBanner post={latestWWUPost} onRead={handleBannerRead} onDismiss={markBannerSeen} />
            )}

            {/* Free chapter gift promo */}
            <div style={{maxWidth: '900px', margin: '0 auto 2rem', padding: '0 1.5rem'}}>
              <GiftPromoCard />
            </div>

            {/* Categories */}
            <div className="vd-categories" data-testid="category-filter">
              {CATEGORIES.map((cat) => (
                <button
                  key={cat}
                  className={`vd-cat ${activeCategory === cat ? 'vd-cat--active' : ''}`}
                  data-testid={`cat-${cat.toLowerCase()}`}
                  onClick={() => setActiveCategory(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>

            {/* Posts Grid */}
            {filteredPosts.length > 0 ? (
              <div className="vd-posts-grid" data-testid="posts-grid">
                {filteredPosts.map(post => (
                  <PostCard key={post.id} post={post} onOpen={setOpenPostId} />
                ))}
              </div>
            ) : (
              <div className="vd-empty" data-testid="daily-empty">
                <img alt="" className="vd-empty-bird" src={HUMMINGBIRD_URL} />
                <p>Nothing here yet for "{activeCategory}"...</p>
                <p className="vd-empty-sub">Check back — the hummingbird never stays still for long.</p>
              </div>
            )}

            {/* Gangsta AI CTA removed — page temporarily down */}

            {/* Subscribe */}
            <div className="vd-subscribe" data-testid="subscribe-section">
              <img alt="" className="vd-sub-bird" src={HUMMINGBIRD_URL} />
              <h2 className="vd-sub-title">Stay Connected</h2>
              <p className="vd-sub-text">Get Cabrini's latest thoughts, teachings, and Village updates delivered to your inbox.</p>
              <form className="vd-sub-form" data-testid="subscribe-form" onSubmit={handleSubscribe}>
                <div className="vd-sub-input-wrap">
                  <Mail size={18} className="vd-sub-icon" />
                  <input
                    className="vd-sub-input"
                    placeholder="Your email..."
                    required
                    data-testid="subscribe-email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <button type="submit" className="vd-sub-btn" data-testid="subscribe-btn">Subscribe</button>
              </form>
            </div>
          </>
        )}
      </div>
    </section>
  );
}
